module.exports = __webpack_public_path__ + "img/bot-logo.6f534ddc.png";